import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { UtilitiesService } from '../../services/utilities.service';
import Swal from 'sweetalert2'
import { DatePipe } from '@angular/common';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-pendings',
    templateUrl: './pendings.component.html',
    styleUrls: ['./pendings.component.css'],
    standalone: false
})
export class PendingsComponent {

  page = 1;
  pageSize = 10;

  list_length = 0;
  items_filter: any[] = [];
  patients: any[] = [];
  items: any[] = [];
  types: any[] = [];

  doctors: any[] = [];
  services: any[] = [];
  slots: any[] = [];
  doctor_slots: any[] = [];
  packages: any[] = [];
  packages_list: any[] = [];

  reasons: any[] = ['NONE',
    'Cancelled by Patient',
    'Cancelled by Doctor',
    'DNA',
    'Departed'
  ];

  rooms: any[] = [
    { 'room_001': 'Tratment Room 1' },
    { 'room_002': 'Tratment Room 2' },
    { 'room_003': 'Tratment Room 3' },
    { 'room_004': 'Tratment Room 4' },
    { 'adult_gym': 'Adults Gym' },
    { 'swim_pool': 'Swimming Pool' },
    { 'paeds_gym': 'Paeds Gym' },
    { 'overbooked': 'Overbooked Room' },
    { 'home_visit': 'Home visiting' },
    { 'home_visit_ob': 'Home visiting (OB)' }
  ];

  token: any;
  role: any;
  name: any;

  appointment_type: any = '';

  Swal = 'sweetalert2'
  textName: any;

  cancel_reason: any = 'NONE';
  item = {
    date: ''
  }

  user_id: any;

  schedual_id: any;
  appointment_id: any;

  saving: boolean = false;
  update_key: any;

  constructor(public utility: UtilitiesService, private modalService: NgbModal, public api: ApiService, private route: ActivatedRoute, private router: Router, public datepipe: DatePipe, public common: CommonService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.role = localStorage.getItem('role');
    this.user_id = localStorage.getItem('id');
    this.name = localStorage.getItem('username');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let id = params['id'] != null ? params['id'] : null;
      let doctor = params['doctor'] != null ? params['doctor'] : null;
      let patient = params['patient'] != null ? params['patient'] : null;
      let role = localStorage.getItem('role');

      this.getItems(doctor, patient);
    });
  }

  getItems(doctor?: any, patient?: any) {
    // logged in doctor, or if admin then all... 
    this.utility.loading = true;
    const sub = this.api.get('appointments/pending', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.items = objects.appointments;

        if (doctor)
          this.items = this.items.filter(i => i.appointment.doctor_id === doctor);

        if (patient)
          this.items = this.items.filter(i => i.appointment.patient_id === patient);

        this.items_filter = this.items;
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  OnUpdate(id: any) {

  }

  close(id: any) {
    Swal.fire({
      title: "Do you want to CLOSE this appointment and mark as COMPLETED?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Save"
    }).then((result) => {
      if (result.isConfirmed) {
        const sub = this.api.update(`appointments/update_status/${id}/COMPLETED`, {}, this.token).subscribe(
          async data => {
            this.getItems();
            Swal.fire({
              title: 'Success!',
              text: 'Updated Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );

        sub.add(() => { this.getItems(); });
      }
    });
  }

  cancel(id: any) {
    Swal.fire({
      title: "Do you want to CANCEL this appointment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Save"
    }).then((result) => {
      if (result.isConfirmed) {
        const sub = this.api.update(`appointments/update_status/${id}/CANCELLED`, {}, this.token).subscribe(
          async data => {
            this.getItems();
            Swal.fire({
              title: 'Success!',
              text: 'Updated Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );

        sub.add(() => { this.getItems(); });
      }
    });
  }

  goToDetails(appointment: any) {
    localStorage.removeItem('appointment');
    localStorage.setItem('appointment', JSON.stringify(appointment));

    this.router.navigate(['view_details']);
  }
}
